import DocReady from '../modules/_doc-ready';

new DocReady( () => {
    //do work
    const pdp = document.querySelector('body.product');
    if(pdp != undefined) {
        
        let int = setTimeout(() => {
            const tab1 = pdp.querySelector('.product-description-container:nth-of-type(2) #tab1');
            const arrow = tab1.querySelector('.icon-down-arrow');
            tab1.style.display = 'list-item';
            if(arrow != null) {
                arrow.classList.add = 'active';
            }
        },1000);
    }
/*
    //when recharge is loaded, the place is changed
    var eleRecharge, newPlace;
    var rechargeInterval = setInterval(function () {
        eleRecharge = document.querySelector(".rc-container-wrapper");
        //console.log('test',eleRecharge);
        newPlace = document.querySelector(".recharge-container");
        
        if (eleRecharge != undefined){
            newPlace.insertBefore(eleRecharge, newPlace.childNodes[0]);
            console.log('end');
            clearInterval(rechargeInterval);} 
    }, 100);
*/

});//end doc ready
